import { categoryColors, fallbackCategoryColor } from '../config';

export const formatYAxisLabel = value => {
	if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
	if (value >= 1000) return `${(value / 1000).toFixed(0)}K`;
	return value.toString();
};

const findCategory = (categories, categoryId) =>
	categories.find(c => c.id === categoryId || c._id === categoryId);

export const toCategoryTotals = (expenses, categories, currency) => {
	const totals = new Map();

	expenses
		.filter(expense => expense.currency === currency)
		.forEach(expense => {
			const category = findCategory(categories, expense.category_id);
			const key = String(
				category?.id ?? category?._id ?? expense.category ?? 'other',
			);
			const name = category?.name ?? expense.category ?? 'Other';
			const colorKey = category?.original_name ?? name;

			const total = totals.get(key) ?? {
				name,
				value: 0,
				color: categoryColors[colorKey] ?? fallbackCategoryColor,
			};
			total.value += Number(expense.amount) || 0;
			totals.set(key, total);
		});

	return [...totals.values()];
};
